import { IconDialogError } from "../../icon";
import { DialogGeneral } from "./dialog";

export class ValidToken {
    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean) => void) | undefined;
    private _dialog: DialogGeneral | undefined;
    private _containerId: string;
    constructor(containerId: string) {
        this._containerId = containerId;  // Gán giá trị containerId    

        this.createModalLabelPoint()
    }
    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }

    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
        } else {
            console.error("State change callback is not set.");
        }
    }

    createModalLabelPoint = () => {
        this._dialog = new DialogGeneral(
            this._containerId,
            this.handleCloseModal
        );
        this._dialog.innerHeader = "Thông báo";
        this._dialog.isModal = true
        this._dialog.minimizeDialog = false;
        this._dialog.zIndex = 1000
        this._dialog.topModal = "50%"
        this._dialog.leftModal = "50%"
        this._dialog.widthModal = '270px'
        this._dialog.heightModal = '130px'
        this._dialog.minHeightModal = 150
        this._dialog.minWidthModal = 150
        this._dialog.enableResize = false
        // Lấy chuỗi HTML của tree view và gán cho innerBody
        this._dialog.innerBody = this._renderBodyModal();

        this._dialog.createDialog();
    }

    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)


        }
    }


    private _containerBody: HTMLDivElement | undefined

    private _renderBodyModal = (): HTMLElement => {
        const containerId = document.querySelector(`#${this._containerId}`)

        this._containerBody = document.createElement('div')
        this._containerBody.className = 'body-dialog-valid-token'
        this._containerBody.innerHTML = `
        <div class='icon-dialog-error' style='width:40px;height:40px'>${IconDialogError()}</div>
            <span style='margin-left:5px'>Token không hợp lệ bạn vui lòng thử lại.</span>
        `
        containerId?.appendChild(this._containerBody)


        return this._containerBody
    }
}